<template lang="pug">
  div
    div.map-container(ref='mapContainer')
    template(v-if="!!google && !!map")
      MapProvider(ref="markerContainer" :google="google" :map="map")
        MapMarker(v-for="(marker, index) in shownMarker" :data="marker" :key="index")
</template>

<script>
import GoogleMapsApiLoader from 'google-maps-api-loader'
import MapProvider from './MapProvider'
import MapMarker from './MapMarker'

export default {
  components: {
    MapProvider,
    MapMarker
  },
  data () {
    return {
      // google オブジェクト
      google: null,
      // map オブジェクト
      map: null,
      // 表示中のマーカー
      shownMarker: []
    }
  },
  props: {
    // 表示したいマーカー
    marker: {
      type: Array,
      default: () => { return [] }
    },
    // ズーム
    zoom: {
      type: Number,
      default: 13
    },
    // 位置情報
    location: {},
    // 住所
    address: {}
  },
  mounted () {
    GoogleMapsApiLoader({
      region: this.$store.getters.apps_mapRegion,
      language: this.$store.getters.apps_mapLanguage,
      apiKey: process.env.VUE_APP_MAP_GOOGLE_KEY
    }).then((google) => {
      this.google = google
      const container = this.$refs.mapContainer

      this.getLocation(this.address, this.location)
        .then(latlng => {
          const {Map, ControlPosition} = this.google.maps
          const config = {
            fullscreenControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            zoomControl: true,
            zoom: this.zoom,
            center: latlng,
            styles: [
              { 'featureType': 'administrative.land_parcel', 'elementType': 'labels', 'stylers': [ { 'visibility': 'off' } ] },
              { 'featureType': 'poi', 'elementType': 'labels.text', 'stylers': [ { 'visibility': 'off' } ] },
              { 'featureType': 'road.arterial', 'elementType': 'labels', 'stylers': [ { 'visibility': 'off' } ] },
              { 'featureType': 'road.highway', 'elementType': 'labels', 'stylers': [ { 'visibility': 'off' } ] },
              { 'featureType': 'road.local', 'stylers': [ { 'visibility': 'off' } ] },
              { 'featureType': 'road.local', 'elementType': 'labels', 'stylers': [ { 'visibility': 'off' } ] }
            ],
            zoomControlOptions: {
              position: ControlPosition.TOP_LEFT
            }
          }

          this.map = new Map(container, config)

          // move event
          this.$watch(() => this.map.getCenter(), (val) => this.$emit('mapMove', val))
          this.$watch(() => this.map.getZoom(), (val) => this.$emit('mapZoom', val))

          // refresh marker
          this.$watch(() => this.marker, (val) => {
            this.refreshMarker(val)
          })
          if (this.marker.length > 0) {
            this.refreshMarker(this.marker)
          }

          // change zoom
          this.$watch(() => this.zoom, (val) => {
            this.map.setZoom(val)
          })

          // change address
          this.$watch(() => this.address, (val) => {
            this.getLocation(val, null)
              .then(latlng => {
                this.map.setCenter(latlng)
              })
          })
          // change location
          this.$watch(() => this.location, {
            handler (val) {
              this.getLocation(null, val)
                .then(latlng => {
                  this.map.setCenter(latlng)
                })
            },
            deep: true
          })

          // complete
          this.$emit('load', {latlng})
        })
    })
  },
  methods: {
    /**
     * 位置情報を取得
     */
    getLocation (address, location) {
      return new Promise((resolve, reject) => {
        const {LatLng} = this.google.maps
        let latlng
        if (location && !Number.isNaN(location.lat) && !Number.isNaN(location.lng)) {
          latlng = new LatLng({
            lat: location.lat,
            lng: location.lng
          })
        } else {
          latlng = new LatLng({
            lat: this.$store.state.apps.mapDefaultLocation.lat,
            lng: this.$store.state.apps.mapDefaultLocation.lng
          })
        }

        if (this.utils.string.isEmptyOrUndef(address)) {
          resolve(latlng)
          return
        }

        const {Geocoder} = this.google.maps
        var geocoder = new Geocoder()
        geocoder.geocode({
          address
        }, (results, status) => {
          if (status === this.google.maps.GeocoderStatus.OK &&
              results[0] &&
              results[0].geometry &&
              results[0].geometry.location) {
            resolve(results[0].geometry.location)
          } else {
            resolve(latlng)
          }
        })
      })
    },
    /**
     * マーカーをリフレッシュ
     */
    refreshMarker (newVal) {
      const self = this
      this.$nextTick(() => {
        self.$refs.markerContainer.$children.forEach(element => {
          element.unload()
        })
        this.$nextTick(() => {
          self.shownMarker = []

          if (newVal instanceof Array && newVal.length > 0) {
            this.$nextTick(() => {
              self.shownMarker = newVal
            })
          }
        })
      })
    }
  }
}
</script>

<style lang="sass" scoped>
.map-container
  width: 100%
  height: 100%
</style>
